module.exports = __webpack_public_path__ + "media/Audio19_a.5730e039.wav";